// extracted by mini-css-extract-plugin
export var backgroundImg = "gridContainer-module--background-img--3cbbe";
export var borderImage = "gridContainer-module--border-image--6579a";
export var cardContainer = "gridContainer-module--card-container--5fec5";
export var heading = "gridContainer-module--heading--eee96";
export var title = "gridContainer-module--title--f369e";